export const selectNews = state => state.get('news').toJS();
